export default __webpack_public_path__ + "static/media/TERMINAL_ICON_01.3ce0b9ad.svg";